export default __webpack_public_path__ + "static/media/messageIcon.3152af49.svg";